import styled from 'styled-components'

import { Box } from '~design-system'

const SelectContainer = styled(Box)`
  z-index: 2;
`

export default SelectContainer
